var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGermlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "germline_icon_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.854,
    cy: 292.498,
    r: 0.793,
    fill: "none",
    stroke: "#000",
    strokeWidth: 0,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "germline_icon_svg__d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.854,
    cy: 292.498,
    r: 0.793,
    fill: "none",
    stroke: "#000",
    strokeWidth: 0,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    paintOrder: "markers fill stroke"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "germline_icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.579,
    height: 1.579,
    x: 3.708,
    y: 291.705,
    ry: 0.186,
    fill: "#fff",
    strokeWidth: 0.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "germline_icon_svg__c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.638,
    height: 0.935,
    x: 1.974,
    y: 293.69,
    rx: 0.21,
    ry: 0.209,
    fill: "#fff",
    strokeWidth: 0.27
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -290.65)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 291.705,
    x: 3.708,
    height: 1.579,
    width: 1.579,
    clipPath: "url(#germline_icon_svg__a)",
    ry: 0,
    transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.529,
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.793,
    cy: 292.498,
    cx: 1.854,
    clipPath: "url(#germline_icon_svg__b)",
    transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.928,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    paintOrder: "markers fill stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.466 294.616v-.777H2.124v.91",
    clipPath: "url(#germline_icon_svg__c)",
    transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.371
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.174 293.685v-1.872h-.963 2.105",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.529
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(1.4262 0 0 1.4262 2.354 -121.303)",
    r: 0.793,
    cy: 292.498,
    cx: 1.854,
    clipPath: "url(#germline_icon_svg__d)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.928,
    strokeLinejoin: "round",
    strokeMiterlimit: 0,
    paintOrder: "markers fill stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    clipPath: "url(#germline_icon_svg__a)",
    width: 1.579,
    height: 1.579,
    x: 3.708,
    y: 291.705,
    transform: "matrix(1.4262 0 0 1.4262 -4.755 -121.314)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.529,
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.104 294.535h.121v.245h-.121zM1.466 294.493h.099v.231h-.099z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.726 296.714l1.875-1.81M.747 295.794l.94-.87M1.667 296.714l.934-.94",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.377
  }), /*#__PURE__*/React.createElement("rect", {
    y: 291.705,
    x: 3.708,
    height: 1.579,
    width: 1.579,
    clipPath: "url(#germline_icon_svg__a)",
    ry: 0,
    transform: "matrix(1.4262 0 0 1.4262 -1.352 -125.36)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.529,
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13 292.668l1.874-1.81M4.15 291.748l.94-.87M5.07 292.668l.934-.94",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.377
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.744 294.916h1.753v1.736H.744zM4.192 290.89h1.712v1.703H4.192z"
  }))));
}

export default SvgGermlineIcon;